import { render } from "./FormToggle.vue?vue&type=template&id=65ed2275"
import script from "./FormToggle.vue?vue&type=script&lang=js"
export * from "./FormToggle.vue?vue&type=script&lang=js"
script.render = render

export default script